// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Projects_wrapper__2xAb7","scrollable":"Projects_scrollable__3H43v","noContent":"Projects_noContent__cYNYV"};